<template>
    <div class="tab-text">
      <section>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Support Phone No.</span>
            <div style="font-size:0.75rem; color:#aaa;">
              A phone number for attendees to call for support
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              name="supportno"
              class="w-full"
              v-model="contactForm.supportno"
              placeholder="Eg., +66872223380"
              onkeypress="return /^[0-9+-]/i.test(event.key)"
            />
            <span class="text-danger text-sm" v-show="errors.has('supportno')">
              {{ errors.first("supportno") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>LINE ID</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              name="name"
              class="w-full"
              v-model="contactForm.lineid"
              placeholder="Eg., SoldOutt"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>LINE Add URL</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{regex: /[@][a-zA-Z0-9]+$/}"
              name="lineAdd"
              class="w-full"
              v-model="contactForm.lineaddurl"
              placeholder="Eg., https://line.me/ti/p/~@soldoutt"
            />
            <span class="text-danger text-sm" v-show="errors.has('lineAdd')">
                {{ errors.first("lineAdd") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Facebook Page</span>
            <div style="font-size:0.75rem; color:#aaa;">
              You can get this from the URL of your Facebook Page
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              name="name"
              class="w-full"
              v-model="contactForm.fbpage"
              placeholder="Eg., SoldOuttLive"
            />
          </div>
        </div>
        <vs-divider></vs-divider>
        <div class="vx-row pt-2 mt-0">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="validateForm"
              >Save
            </vs-button>
            <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
      </section>
    </div>
</template>
<script>
import { Validator } from "vee-validate";
import moment from "moment";
import { mapState } from "vuex";
import Service from "@/services";

import { currencyList, protypeList } from "@/utils/Constants";
import { timezones } from "@/utils/Timezones";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { contactForm, basicForm }from "@/utils/eventForm";

const dict = {
  form: {
    supportno: {
      required: "Please enter support phone number"
    },
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: {},
  props: {
    event: null,
    role: null,
    contactForm: contactForm,
    folder: null,
    basicForm: basicForm
  },
  data() {
    return {};
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submitContact();
        } else {
          // form have errors
        }
      });
    },
    submitContact() {
      this.contactForm.e = this.folder;
      this.contactForm.lineaddurl = this.contactForm.lineaddurl === 'null' ? '': this.contactForm.lineaddurl

      this.$vs.loading();

      const data = {
        ...this.basicForm,
        ...this.contactForm,
        lineaddurl: this.contactForm.lineaddurl === '' ? 'null': this.contactForm.lineaddurl,
        lineid: this.contactForm.lineid === '' ? 'null': this.contactForm.lineid,
        fbpage: this.contactForm.fbpage === '' ? 'null': this.contactForm.fbpage,
        pay_creditcard: (this.event.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard ,
        pay_transfer: (this.event.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer ,
        fields_status: this.event.fields_status === null ? null: this.basicForm.fields_status
      }

      Service.Event.update(data)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push(`/dash`)
    }
  }
};
</script>
